<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 text-center my-5">
                    <h3 class="heading">Associates &#x22C5; Partners &#x22C5; Sponsors </h3>
                    <hr class="custom-hr">

                </div>
            </div>
            <div class="row">
                <div class="col-12 my-5">
                    <carousel :nav="false" :autoplay="true"  :dots="false"  :loop="true"  :margin="10" :autoWidth="true" :stagePadding="50" :responsive="{0:{items:1,nav:false},800:{items:12,nav:false}}">
                        <div class="sponsor">
                            <img src="../assets/images/sponsors/india.png" alt="">
                        </div>
                        <div class="sponsor">
                            <img src="../assets/images/sponsors/Czech Embassy Logo.png" alt="">
                        </div>
                        <div class="sponsor">
                            <img src="../assets/images/sponsors/France.png" alt="">
                        </div>
                        <div class="sponsor">
                            <img src="../assets/images/sponsors/Hungary - Logo.jpg" alt="">
                        </div>
                        <div class="sponsor">
                            <img src="../assets/images/sponsors/Portugal Logo 2nd.jpg" alt="">
                        </div>
                        <div class="sponsor">
                            <img src="../assets/images/sponsors/mexico.png" alt="">
                        </div>
                        <div class="sponsor">
                            <img src="../assets/images/sponsors/Institut Français_India_HD-01.png" alt="">
                        </div>
                        <div class="sponsor">
                            <img src="../assets/images/sponsors/MTV.jpg" alt="">
                        </div>
                        <div class="sponsor">
                            <img src="../assets/images/sponsors/WTS_logo_Oct-2012-bigger.png" alt="">
                        </div>
                        <div class="sponsor">
                            <img src="../assets/images/sponsors/Wynk-logo.png" alt="">
                        </div>
                          <div class="sponsor">
                            <img src="../assets/images/sponsors/frooto LOGO.jpg" alt="">
                        </div>
                        <div class="sponsor">
                            <img src="../assets/images/sponsors/sony_laptop-prices-in-India.jpg" alt="">
                        </div> 
                    </carousel>
                </div>
            </div>
        </div>
      
    </div>
</template>

<script>
import carousel from 'vue-owl-carousel'
export default {
    components:{
        carousel
    }
}
</script>


<style scoped>
    .sponsor{
        width: 10rem;
        height: 10rem;
    }

    .sponsor img{
        height: 100%;
        width: 100%;
        object-position: center;
        object-fit: contain;
    }
 @media (max-width: 700px){
    .sponsor{
        width: 8rem;
        height: 8rem;
    }
 }    
</style>

